import React, { useState } from 'react';
import { Box, SvgIcon, Typography } from '@material-ui/core';
import { lighten, useTheme } from '@material-ui/core/styles';

export const ActionButton = ({
    icon,
    label,
    onClick,
}: {
    icon: React.ReactNode;
    label: string;
    onClick?: () => void;
}) => {
    const theme = useTheme();
    const [hover, setHover] = useState(false);

    const hoverStyles = {
        transform: 'scale(1.02)',
    };

    return (
        <Box
            style={{
                cursor: 'pointer',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: 10,
                transition: '0.4s',
                ...(hover && hoverStyles),
            }}
            onMouseEnter={() => setHover(true)}
            onMouseLeave={() => setHover(false)}
        >
            <Box
                style={{
                    transition: '0.4s',
                    height: 120,
                    width: 120,
                    backgroundColor: lighten(theme.palette.primary.main, 0.5),
                    ...(hover && {
                        backgroundColor: lighten(
                            theme.palette.primary.main,
                            0.4
                        ),
                    }),
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    borderRadius: 8,
                    color: theme.palette.getContrastText(
                        lighten(theme.palette.primary.main, 0.5)
                    ),
                }}
                onClick={onClick}
            >
                <SvgIcon
                    style={{
                        transition: '0.4s',
                        ...(hover && hoverStyles),
                    }}
                >
                    {icon}
                </SvgIcon>
            </Box>
            <Typography variant="body1" color="textPrimary">
                {label}
            </Typography>
        </Box>
    );
};
